export const reviews = [
  {
    id: 'one',
    reviewer: 'Mark',
    timeStamp: 'August 28',
    review: 'Love it! Gorgerous little piece for my nightstand!'
  },
  {
    id: 'two',
    reviewer: 'Molly',
    timeStamp: 'Jul 10',
    review: 'I love it! Thank you so much'
  },
  {
    id: 'three',
    reviewer: 'abrayard',
    timeStamp: 'Jul 21',
    review:
      'Very satisfied with my order, the artwork is beautiful and the parcel well packaged!'
  }
];
